import BuyerMasterLayout from "layouts/BuyerMasterLayout";
import React, { useContext, useEffect, useState } from "react";
import PropertyCards from "../properties/PropertyCards/PropertyCards";
import AppContext from "context/AppContext";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import Swal from "sweetalert2";

const BuyerProperty = () => {
  const { baseUrl,authToken } = useContext(AppContext);
  const [wishlistProperties, setWishlistProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  const [allProperties, setAllProperties] = useState([]);

  const viewAllWishlist = () => {
    setLoading(true);
    const formData = new FormData();
    // formData.append("exbuyer_id", loggedInBuyer?.id);
    formData.append("exbuyer_id", 1);

    axios
      .post(`${baseUrl}/buyer/wishlist/viewAllWishlist`, formData, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((response) => {
        console.log("Property Details:", response.data);
        setWishlistProperties(response.data.wishlist);
        setLoading(false);
      })
      .catch((error) => {
        console.log("Error fetching property details:", error);
        setLoading(false);
      });
  };

  // Delete Wishlist Property

const deleteWishlist = (wishlistId) => {
  const formData = new FormData();

  formData.append("id", wishlistId);

  axios
    .post(`${baseUrl}/buyer/wishlist/deleteWishlist`, formData, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
    .then((response) => {
      console.log("Delete Wishlist Response:", response.data);

      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "Property has been removed from your wishlist.",
          confirmButtonText: "OK",
          confirmButtonColor: "#000000",
        }).then(() => {
          viewAllWishlist();
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed!",
          text: response.data.message || "Unable to delete property.",
          confirmButtonColor: "#000000",
        });
      }
    })
    .catch((error) => {
      console.log("Error deleting wishlist:", error);
    });
};

  useEffect(() => {
    viewAllWishlist();
  }, []);
  return (
    <>
      <BuyerMasterLayout>
        {/* Property Grid - 3 columns */}
        <div className="property-grid">
          {loading ? (
            <div className="buyerproperty-loading-container">
              <Spinner
                animation="border"
                role="status"
                className="buyerproperty-spinner"
              />

              <span className="buyerproperty-loading-text">
                Loading properties...
              </span>
            </div>
          ) : wishlistProperties.length > 0 ? (
            wishlistProperties.map((item) => (
              <PropertyCards
                key={item.id}
                property={item.exproperty}
                wishlistId={item.id}
                onDelete={deleteWishlist}
                showDelete={true}
              />
            ))
          ) : (
            <div className="empty-state">
              <h3>No Properties Found</h3>
              <p>Try selecting a different category or filter.</p>
            </div>
          )}
        </div>
      </BuyerMasterLayout>
    </>
  );
};
export default BuyerProperty;
